import React from "react";
import Image from "../../../assets/images/login.webp";
const BreadCrump = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${Image})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: 'center'
      }}
    className="min-h-[150px]"></div>
  );
};

export default BreadCrump;
